export const ServiceDetailWrapper = 'w-full h-full pt-12'

export const ServiceDetailInfo = 'max-w-5xl mx-auto h-full flex flex-col'
export const ServiceDetailInfoService = 'flex flex-col gap-6 pt-12'
export const ServiceDetailInfoTitle = 'flex gap-2'
export const ServiceDetailInfoServiceDescription = 'flex flex-col gap-6 p-6'
export const ServiceDetailInfoServiceActions = 'flex justify-between gap-6'
